import React from 'react';

/**
 * Property row — desktop keeps the compact dense look; mobile renders as an
 * iOS-style inset table row with a 44pt-tap-target height, full-width hit
 * area, and a hairline separator between rows.
 */
const CompactPropertyRow = ({ icon: Icon, label, children, onClick, className = '' }) => {
  return (
    <div
      onClick={onClick}
      className={`flex items-center gap-3 transition-colors
        px-3 py-[5px] min-h-[32px] rounded-lg
        max-md:px-4 max-md:py-3 max-md:min-h-[48px] max-md:rounded-none
        max-md:border-b max-md:border-border max-md:dark:border-white/[0.06]
        max-md:last:border-b-0
        ${onClick ? 'cursor-pointer hover:bg-muted dark:hover:bg-white/[0.04] max-md:active:bg-accent max-md:dark:active:bg-white/[0.06]' : ''} ${className}`}
    >
      {Icon && <Icon className="w-[15px] h-[15px] max-md:w-[18px] max-md:h-[18px] text-muted-foreground max-md:text-foreground/70 flex-shrink-0" />}
      <span className="text-[13px] max-md:text-[15px] text-muted-foreground max-md:text-foreground w-[80px] max-md:w-auto flex-shrink-0 select-none">{label}</span>
      <div className="flex-1 min-w-0 text-[13px] max-md:text-[15px] text-foreground/80 dark:text-foreground/80 max-md:text-right max-md:flex max-md:items-center max-md:justify-end max-md:gap-2 max-md:[&>button:not([role=switch])]:!bg-transparent max-md:[&>button:not([role=switch])]:!p-0">
        {children}
      </div>
    </div>
  );
};

export default CompactPropertyRow;
